import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import { useCallback } from 'sb-hooks'
import { array } from 'common/helpers'

import Star from 'components/ui/Star/Star'

import s from './Stars.scss'


const Stars = (props) => {
  const {
    className, starClassName, starIconClassName,
    style, count, withNumbers,
    active, isBlack, isRed,
    onClick,
  } = props

  const isClickable = typeof onClick === 'function'

  const createHandleClick = useCallback((num) => () => {
    if (isClickable) {
      onClick(num)
    }
  }, [ isClickable, onClick ])

  const adaProps = isClickable
    ? { role: 'button', tabIndex: 0 }
    : {}

  return (
    <div className={cx(s.stars, className, { [s.clickable]: isClickable })} style={style} data-testid="ratingStars">
      {
        array.range(1, count).map((num, index) => withNumbers ? (
          <div
            key={index}
            className={s.star}
            onClick={isClickable ? createHandleClick(num) : undefined}
            {...adaProps}
          >
            <Star
              className={starClassName}
              iconClassName={starIconClassName}
              active={active}
              isBlack={isBlack}
              isRed={isRed}
            />
            <div className={s.number}>{num}</div>
          </div>
        ) : (
          <Star
            key={index}
            className={cx(s.star, starClassName)}
            iconClassName={starIconClassName}
            active={active}
            isBlack={isBlack}
            isRed={isRed}
            onClick={isClickable ? createHandleClick(num) : undefined}
          />
        ))
      }
    </div>
  )
}

Stars.propTypes = {
  className: PropTypes.string,
  starClassName: PropTypes.string,
  starIconClassName: PropTypes.string,
  style: PropTypes.object,
  active: PropTypes.bool,
  isBlack: PropTypes.bool,
  onClick: PropTypes.func,
  count: PropTypes.number,
}

Stars.defaultProps = {
  count: 5,
}


export default Stars
